import { Controller } from 'stimulus';

export default class extends Controller {
  static outlets = ['accordion', 'content'];
  static targets = ['switcher'];

  connect() {
    this.accordionOutlets.forEach((accordion) => {
      if (accordion.isOpenValue) {
        this.manageAccordions({ params: { id: accordion.element.getAttribute('id') } });
      }
    });
  }

  manageAccordions(event) {
    this.#openOnlyAccordionById(event.params.id);
    this.#setOpenAccordionHeight();
  }

  manageAccordionsAndToggleThis(event) {
    this.accordionOutlets.forEach((accordion) => {
      accordion.opened = accordion.element.id === event.params.id ? !accordion.opened : false;
    });
    this.#setOpenAccordionHeight();
  }

  #setOpenAccordionHeight() {
    // calculate combined height of all accordion headers
    const combinedHeadersHeight = this.accordionOutlets.reduce(
      (sum, accordion) => sum + accordion.headerTarget.getBoundingClientRect().height,
      0
    );
    const swithcerHeight = this.switcherTarget.getBoundingClientRect().height;
    const rightPanelHeight = this.element.getBoundingClientRect().height;
    const dropdownContentHeight = rightPanelHeight - combinedHeadersHeight - swithcerHeight;

    // set opened accordion height and reduce height of all others to zero
    this.accordionOutlets.forEach((accordion) => {
      accordion.expansibleTarget.style.height = accordion.opened
        ? `${dropdownContentHeight}px`
        : '0';
    });
  }

  #openOnlyAccordionById(id) {
    this.accordionOutlets.forEach((accordion) => {
      accordion.opened = id === accordion.element.id;
    });
  }
}
